import { Link } from 'react-router';
import { Atom, Calculator, FlaskConical } from 'lucide-react';
import type { SubjectPresentation } from '../../data/subjects';
import { START_NEW_SUBJECT_CONVERSATION_STATE } from '../../lib/subjectNavigation';

function SubjectIcon({ icon }: { icon: SubjectPresentation['icon'] }) {
  const props = { size: 48, strokeWidth: 1.75, color: 'var(--icon-accent)' };
  if (icon === 'calculator') return <Calculator {...props} aria-hidden />;
  if (icon === 'atom') return <Atom {...props} aria-hidden />;
  if (icon === 'flask-conical') return <FlaskConical {...props} aria-hidden />;
  return <img src="/assets/icon-brain.png" alt="" width={48} height={48} />;
}

export default function SubjectCard({ subject }: { subject: SubjectPresentation }) {
  return (
    <Link
      to={subject.route}
      state={START_NEW_SUBJECT_CONVERSATION_STATE}
      style={{
        textDecoration: 'none',
        display: 'block',
        background: 'var(--surface-card)',
        borderRadius: 'var(--radius-md)',
        boxShadow: 'var(--shadow-card)',
        padding: '28px 24px',
        minHeight: 170,
        transition: 'box-shadow var(--transition-base), transform var(--transition-base)',
      }}
      className="subject-card"
    >
      <div style={{ marginBottom: 16 }}>
        <SubjectIcon icon={subject.icon} />
      </div>
      <div
        style={{
          fontSize: 20,
          fontWeight: 700,
          color: 'var(--text-heading)',
          fontFamily: 'var(--font-display)',
        }}
      >
        {subject.label}
      </div>
    </Link>
  );
}
